 export enum UtilisateurOrigineEnum {
NonDefini = 0,
Salarie = 1,
UtilisateurExterne = 2,
}


// WEBPACK FOOTER //
// ./src/dto/GenApi.iNotPaie.Dto/UtilisateurOrigineEnum.ts